import { render, staticRenderFns } from "./SelectMulGift.vue?vue&type=template&id=9735284a&scoped=true"
import script from "./SelectMulGift.vue?vue&type=script&lang=js"
export * from "./SelectMulGift.vue?vue&type=script&lang=js"
import style0 from "./SelectMulGift.vue?vue&type=style&index=0&id=9735284a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9735284a",
  null
  
)

export default component.exports